<fui-page>
  <fui-page-pane>
    <fui-page-header [description]="description"
      [title]="title">

      <fui-filter-form-context>
        <div class="form" id="search">
          <div class="form-main">
            @if (showColumnSearch) {
              <div class="form-main-fields">
                <fui-search-control [(ngModel)]="nameSearch"
                  [label]="'fhm.common.label.search'"
                  (valueChange)="nameSearchChanged.emit(nameSearch)"
                [placeholder]="' '"></fui-search-control>
              </div>
            }
            <ng-content select=".searchControls"></ng-content>
          </div>
        </div>
      </fui-filter-form-context>

    </fui-page-header>
    <fui-page-body>
      <fui-page-main>
        <fui-page-subject>
          <ng-content></ng-content>
        </fui-page-subject>
      </fui-page-main>
    </fui-page-body>
  </fui-page-pane>
  @if (showDone || showSave) {
    <fui-page-footer>
      <ng-template #FUIPageFooterButtons>
        <fui-buttons>
          <fui-action-button class="cancel-button"
            [title]="showSave ? 'fhm.common.button.cancel' : 'fhm.common.button.done'"
            (click)="doneClicked.emit($event)">
            <fui-icon [height]="12" [icon]="'close'" [width]="12"></fui-icon>
          </fui-action-button>
          @if (showSave) {
            <fui-action-button [title]="saveLabel"
              (click)="saveClicked.emit($event)">
              <fui-icon [height]="12" [icon]="'success'" [width]="12"></fui-icon>
            </fui-action-button>
          }
          @if (showComplete) {
            <fui-action-button [title]="completeLabel"
              (click)="completeClicked.emit($event)">
              <fui-icon [height]="12" [icon]="'success'" [width]="12"></fui-icon>
            </fui-action-button>
          }
        </fui-buttons>
      </ng-template>
    </fui-page-footer>
  }

</fui-page>
